import AccessTimeFilledRoundedIcon from "@mui/icons-material/AccessTimeFilledRounded";
import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import BlueLeftArrow14pxSvg from "../../assets/images/icons/BlueLeftArrow14pxSvg";
import BlueRightArrow14pxSvg from "../../assets/images/icons/BlueRightArrow14pxSvg";
import DashboardIcon20pxSvg from "../../assets/images/icons/DashboardIcon20pxSvg";
import UserGroupIcon20pxSvg from "../../assets/images/icons/UserGroupIcon20pxSvg";
import facialSense_mini_logo from "../../assets/images/logo/FacialSenseIcon.png";
import facialSense_logo from "../../assets/images/logo/CheckIDBioSense_light.svg";
import { DrawerCollapseIconButton } from "../../components/StyledButton";
import { useSettings } from "../../context/SettingsContext";
import AdminTaskIcon20pxSvg from "./../../assets/images/icons/AdminTaskIcon20pxSvg";
import DeviceIcon20pxSvg from "./../../assets/images/icons/DeviceIcon20pxSvg";
import EventLogIcon20pxSvg from "./../../assets/images/icons/EventLogIcon20pxSvg";
import LeaveHolidayIcon20pxSvg from "./../../assets/images/icons/LeaveHolidayIcon20pxSvg";
import ReportIcon20pxSvg from "./../../assets/images/icons/ReportIcon20pxSvg";
import SettingIcon20pxSvg from "./../../assets/images/icons/SettingIcon20pxSvg";
import ShiftRosterIcon20pxSvg from "./../../assets/images/icons/ShiftRosterIcon20pxSvg";
import SubscriptionIcon20pxSvg from "./../../assets/images/icons/SubscriptionIcon20pxSvg";
import UserIcon20pxSvg from "./../../assets/images/icons/UserIcon20pxSvg";
import { useAuth } from "../../context/AuthContext";
import BusinessIcon from "@mui/icons-material/Business";
import company_logo from "../../assets/images/logo/my-company-logo.png";
import Tooltip from "@mui/material/Tooltip";
import { vi, fr, ja } from "date-fns/locale";
import { getCompany, switchCompany } from "../../axios/Company/CompanyApi";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import DefaultTooltip from "../../components/DefaultTooltip";
import { getAccountList } from "../../axios/Account/AccountApi";
import { toast } from "react-toastify";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { formatInTimeZone } from "date-fns-tz";
import {
  Avatar,
  Box,
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import VisitorManagement20pxSvg from "../../assets/images/icons/VisitorManagement20pxSvg";
import { useLoading } from "../../context/LoadingContext";

dayjs.extend(utc);
dayjs.extend(timezone);

const DrawerData = [
  {
    icon: <DashboardIcon20pxSvg />,
    display: "drawer.dashboard",
    linkTo: "/controlpanel/dashboard",
  },
  {
    icon: <UserIcon20pxSvg />,
    display: "drawer.user-management",
    linkTo: "/controlpanel/user-management",
  },
  {
    icon: <UserGroupIcon20pxSvg />,
    display: "drawer.user-groups",
    linkTo: "/controlpanel/user-groups-management",
  },
  {
    icon: <ShiftRosterIcon20pxSvg />,
    display: "drawer.shift-and-roster",
    linkTo: "/controlpanel/shift-and-roster-management",
  },
  {
    icon: <VisitorManagement20pxSvg />,
    display: "drawer.visitor-management",
    linkTo: "/controlpanel/visitor-management",
  },
  {
    icon: <LeaveHolidayIcon20pxSvg />,
    display: "drawer.leave-and-holiday",
    linkTo: "/controlpanel/leave-and-holiday-management",
  },
  {
    icon: <DeviceIcon20pxSvg />,
    display: "drawer.devices",
    linkTo: "/controlpanel/devices-management",
  },
  {
    icon: <EventLogIcon20pxSvg />,
    display: "drawer.event-log",
    linkTo: "/controlpanel/event-log-management",
  },
  {
    icon: <ReportIcon20pxSvg />,
    display: "drawer.reports",
    linkTo: "/controlpanel/reports",
  },
  {
    icon: <SettingIcon20pxSvg />,
    display: "drawer.settings",
    linkTo: "/controlpanel/settings",
  },
  { icon: <SubscriptionIcon20pxSvg />, display: "drawer.subscription" },
  { icon: <AdminTaskIcon20pxSvg />, display: "drawer.admin-tasks" },
  {
    icon: <AccessTimeFilledRoundedIcon sx={{ fontSize: "20px" }} />,
    display: "drawer.timesheet",
  },
];

const CounDown = ({ dateFormat, timeFormat }) => {
  const { i18n } = useTranslation();
  const {
    genaralSettingDateFormat,
    genaralSettingTimeFormat,
    genaralSettingTimeZone,
    isAdmin
  } = useAuth();

  const [currentDateTime, setCurrentDateTime] = useState(Date.now());
  const currentLang = i18n.language;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const browserTZ = dayjs.tz.guess();
  const timeZone = browserTZ || "UTC";

  const formatTime = formatInTimeZone(
    currentDateTime,
    timeZone,
    genaralSettingTimeFormat || timeFormat
  );

  const formattedDate = formatInTimeZone(
    currentDateTime,
    timeZone,
    genaralSettingDateFormat || dateFormat
  );

  const dayOfWeek = formatInTimeZone(
    currentDateTime,
    timeZone,
    "EEEE"
  );

  const dayOfWeekVi = formatInTimeZone(
    currentDateTime,
    timeZone,
    "EEEE",
    { locale: vi }
  );

  return (
    <p className="text-center">
      <span className="font-bold text-xl text-[#0057FF]">
        {formatTime}
      </span>
      <br />
      <span className="font-bold text-xl text-[#6B7280]">
        {currentLang === "en" ? (
          <span className="text-sm">
            {formattedDate} ({dayOfWeek})
          </span>
        ) : (
          <span className="text-sm">
            {formattedDate} ({dayOfWeekVi})
          </span>
        )}
      </span>
    </p>
  );
};


const resolveCompanyLogoSrc = (logo, fallback) => {
  if (!logo) return fallback;
  if (typeof logo === "string" && logo.startsWith("data:image")) {
    return logo;
  }
  const clean = String(logo).replace(/\s/g, "");
  if (/^([A-Za-z0-9+/=])+$/i.test(clean)) {
    return `data:image/png;base64,${clean}`;
  }
  return fallback;
};

const Drawer = ({ roles, isCollapse, setIsCollapse }) => {
  const { settings } = useSettings();
  const { t } = useTranslation();
  const location = useLocation();
  const [isSm, setIsSm] = useState(false);
  const { genaralSettingDateFormat, genaralSettingTimeFormat, profile, refreshProfile, refreshCount, setStatusSwitch, genaralSettingTimeZone, isAdmin } = useAuth();
  const [show, hide] = useLoading();
  const [companyList, setCompanyList] = useState([]);
  const [openCompanyPopper, setOpenCompanyPopper] = useState(false);
  const [prevImageUrl, setPrevImageUrl] = useState(company_logo);
  const anchorRefCompany = useRef(null);

  const handleToggleCompany = () => {
    setOpenCompanyPopper((prevOpen) => !prevOpen);
  };

  const handleCloseCompany = (event) => {
    if (anchorRefCompany.current && anchorRefCompany.current.contains(event.target)) {
      return;
    }
    setOpenCompanyPopper(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          langId: localStorage.getItem("i18nextLngId"),
        };
        const response = await getAccountList(payload);
        setCompanyList(response.data.data || []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [profile.companyId, refreshCount]);

  // Giống LoginOptionsDialog: chỉ hiện account ACTIVE với quyền admin/user
  const switchableCompanies = companyList.filter(
    (item) =>
      (item.permissonId === 2 || item.permissonId === 3) &&
      item.active === "ACTIVE"
  );

  const handleSwitchCompany = async (company) => {
    // Không switch lại chính company đang đăng nhập
    if (company.companyId === profile?.companyId) {
      setOpenCompanyPopper(false);
      return;
    }

    show();
    try {
      const payload = {
        ...company,
        langId: localStorage.getItem("i18nextLngId"),
      };

      const response = await switchCompany(payload);

      if (response.data.code === 200) {
        const code = response?.data?.data?.responseCode;

        if (code === undefined || code === 0) {
          // Cập nhật logo ngay, tránh flash logo cũ trong lúc refresh profile
          setPrevImageUrl(
            resolveCompanyLogoSrc(company.companyLogo, company_logo)
          );
          // Cùng flow LoginOptionsDialog → AuthContext gọi fetchAccount
          setStatusSwitch(true);
          refreshProfile();
          setOpenCompanyPopper(false);
        } else {
          toast.error(response.data.data.message);
        }
      } else if (response.data.code === 500) {
        toast.error(response.data.message);
      } else {
        toast.error(
          response.data.data?.responseCode
            ? response.data.data.message
            : response.data.data?.fieldErrors?.[0]?.message || response.data.message
        );
      }
    } catch (error) {
      toast.error(error?.message || "Switch company failed");
    } finally {
      hide();
    }
  };

  // Chỉ fetch logo từ API khi đổi company — sau update cùng company dùng profile.companyLogo
  // (tránh refreshCount → getCompany trả bản cũ ghi đè logo vừa update)
  useEffect(() => {
    if (!profile.companyId) return;
    if (profile?.companyLogo) {
      setPrevImageUrl(
        resolveCompanyLogoSrc(profile.companyLogo, company_logo)
      );
      return;
    }

    const fetchDataCompany = async () => {
      try {
        const getDetailCompany = await getCompany(
          profile.companyId,
          localStorage.getItem("i18nextLngId")
        );
        const data = getDetailCompany.data.data;
        setPrevImageUrl(
          resolveCompanyLogoSrc(data?.[0]?.companyLogo, company_logo)
        );
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataCompany();
  }, [profile.companyId]);

  // Đồng bộ logo drawer ngay khi profile đổi (update company / switch)
  useEffect(() => {
    if (!profile?.companyLogo) return;
    setPrevImageUrl(
      resolveCompanyLogoSrc(profile.companyLogo, company_logo)
    );
    // Cập nhật logo trong danh sách switch company cho company hiện tại
    setCompanyList((prev) =>
      prev.map((item) =>
        item.companyId === profile.companyId
          ? { ...item, companyLogo: profile.companyLogo, company: profile.company || item.company }
          : item
      )
    );
  }, [profile?.companyLogo, profile?.company, profile?.companyId]);

  useEffect(() => {
    const handleResize = () => {
      setIsSm(window.innerWidth < 540);
      setIsCollapse(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setIsCollapse]);

  const formatCompanyName = (name) =>
    name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const getDrawerTourId = (linkTo) => {
    if (!linkTo) return undefined;
    const pageSlug = linkTo.replace("/controlpanel/", "");
    return `drawer-${pageSlug}`;
  };

  return (
    <div
      className={`drawer-container
        ${isSm && isCollapse ? "hidden" : ""}
        ${isCollapse ? "mini3" : ""}
        ${isSm ? "mini" : ""}
        ${!isCollapse ? "mini2" : ""}
        
    h-screen
    min-h-0
    flex flex-col
  `}
    >

      {/* Top section */}
      <div>
        <div className="drawer-title flex justify-center px-1 mb-5">
          {isSm || isCollapse ? (
            <img
              src={facialSense_mini_logo}
              alt="logo-mobile"
              className="w-[60px]"
            />
          ) : (
            <div className="flex flex-col items-center">
              <img src={facialSense_logo} alt="" className="w-[250px]" />
              {/* <p className="text-center text-[12px] font-bold uppercase text-[#94A3B8] pt-2 px-5">
                {t("drawer.biometric-attendance-management-system")}
              </p> */}
            </div>
          )}
        </div>

        {!isSm && !isCollapse && (
          // <CounDown dateFormat={settings.dateFormat} timeFormat={settings.timeFormat} />
          <CounDown
            dateFormat={settings.dateFormat}
            timeFormat={settings.timeFormat}
          />
        )}

        {isCollapse ? (<div className="border border-b-[#DBE8FF] mt-24 mb-2 w-[50%] mx-auto"></div>) : (<div className="border border-b-[#DBE8FF] mt-5 mb-2 w-[85%] mx-auto"></div>)}

      </div>

      {/* Middle scrollable menu */}
      <div
        tabIndex={0}
        className="
    drawer-body flex-1 overflow-auto
    sb-hide sb-show sb-thumb
  "
      >
        <ul className="drawer-list font-medium">
          {DrawerData
            .filter((item) => {
              // if (item.linkTo === "/controlpanel/user-management") {
              //   return isAdmin;
              // }

              return roles.some((r) =>
                item.linkTo?.includes(r.urlPageOfRole)
              );
            })
            .map((value, index) => {
              const isActive = location.pathname === value.linkTo;

              const itemContent = (
                <li
                  data-tour={getDrawerTourId(value.linkTo)}
                  className={`drawer-item 
          ${isActive ? "active" : ""} 
          ${value.disabled ? "opacity-50 cursor-not-allowed" : ""}
        `}
                >
                  {value.icon}

                  {!isCollapse && (
                    <p className="text-sm">{t(value.display)}</p>
                  )}
                </li>
              );

              const tooltipTitle = value.disabled
                ? t("common.developing")
                : t(value.display);

              return value.disabled ? (
                <Tooltip
                  key={index}
                  title={tooltipTitle}
                  placement="right"
                  arrow
                >
                  <div>{itemContent}</div>
                </Tooltip>
              ) : (
                <Link to={value.linkTo} key={index}>
                  {isCollapse && !isSm ? (
                    <Tooltip
                      title={tooltipTitle}
                      placement="right"
                      arrow
                    >
                      <div>{itemContent}</div>
                    </Tooltip>
                  ) : (
                    itemContent
                  )}
                </Link>
              );
            })}
        </ul>
      </div>

      {/* Bottom fixed section */}
      <div className="px-6">
        <Tooltip
          title={<div>{profile.company}</div>}
          placement="top"
          arrow
        >
          <div className="border-t border-[#DBE8FF] py-3">
            <div
              ref={anchorRefCompany}
              onClick={handleToggleCompany}
              className={`cursor-pointer flex items-center justify-center md:justify-start gap-3 px-0 py-0
        ${isSm || isCollapse
                  ? ""
                  : "md:px-4 md:py-2 md:border md:border-[#DBE8FF]"
                }
        rounded-[8px] bg-white w-full`}
            >
              <img
                key={prevImageUrl?.slice?.(-32) || "company-logo"}
                src={prevImageUrl}
                alt="Company Logo"
                className="w-[48px] h-[48px] object-contain rounded"
              />

              <p
                className="
    font-medium
    text-[#1F2937]

    max-w-[220px]
    mx-auto

    overflow-hidden
    text-ellipsis
    line-clamp-2
  "
              >
                {profile.company}
              </p>


            </div>
          </div>
        </Tooltip>

        <Popper
          open={openCompanyPopper}
          anchorEl={anchorRefCompany.current}
          placement="top-end"
          transition
          disablePortal
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [0, 20],
              },
            },
          ]}
          className="z-[1300] top-2"
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps}>
              <Paper
                className="min-w-[360px] rounded-xl shadow-xl"
              >
                <ClickAwayListener onClickAway={handleCloseCompany}>
                  <Box className="p-4">
                    {/* Title */}


                    {/* Company list */}
                    <Box className="flex flex-col gap-2 max-h-[400px] overflow-y-auto">
                      <p className="text-[18px] font-semibold mb-3">
                        {t('common.switch-company')}
                      </p>
                      {switchableCompanies.map((company) => {
                        const isSelected =
                          company.companyId === profile.companyId;

                        return (
                          <Box
                            key={`${company.companyId}-${company.permissonId}`}
                            onClick={() => handleSwitchCompany(company)}
                            className={`
    cursor-pointer
    flex items-center gap-3
    rounded-lg border p-3
    ${isSelected
                                ? "border-blue-500 bg-blue-50"
                                : "border-gray-200 hover:bg-gray-50"}
  `}
                          >
                            {/* Logo */}
                            <img
                              src={
                                company.companyLogo
                                  ? `data:image/png;base64,${company.companyLogo}`
                                  : company_logo
                              }
                              alt="Company Logo"
                              className="w-[48px] h-[48px] object-contain rounded"
                            />

                            {/* Text + check */}
                            <div className="flex items-start gap-2 flex-1 min-w-0">
                              <Tooltip title={company.companyName} arrow>
                                <p
                                  className="
          text-sm font-medium text-[#1F2937]
          flex-1 min-w-0
          overflow-hidden
          line-clamp-2
        "
                                >
                                  {company.companyName}
                                </p>
                              </Tooltip>

                            </div>
                            <div>
                              {isSelected && (
                                <CheckRoundedIcon
                                  className="text-blue-500 shrink-0 mt-[2px]"
                                  fontSize="small"
                                />
                              )}
                            </div>
                          </Box>

                        );
                      })}
                    </Box>
                  </Box>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

      </div>

    </div>
  );
};

export default Drawer;
